import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import songs from "./songs";

const PASSWORD = "5459";

function Results() {
  const [authorized, setAuthorized] = useState(false);
  const [input, setInput] = useState("");
  const [totals, setTotals] = useState([]);

  useEffect(() => {
    if (!authorized) return;

    async function fetchVotes() {
      const snapshot = await getDocs(collection(db, "votes"));
      const scoreMap = {};

      snapshot.forEach(doc => {
        const data = doc.data();
        data.votes.forEach(({ songId, points }) => {
          scoreMap[songId] = (scoreMap[songId] || 0) + points;
        });
      });

      const result = songs.map(song => ({
        ...song,
        total: scoreMap[song.id] || 0,
      }));

      result.sort((a, b) => b.total - a.total);
      setTotals(result);
    }

    fetchVotes();
  }, [authorized]);

  function handleAccess(e) {
    e.preventDefault();
    if (input === PASSWORD) {
      setAuthorized(true);
    } else {
      alert("❌ PIN incorrecto");
      setInput("");
    }
  }

  if (!authorized) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2>Introduce PIN de seguridad</h2>
        <form onSubmit={handleAccess}>
          <input
            type="password"
            maxLength={4}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            style={{
              fontSize: "2rem",
              padding: "0.5rem",
              textAlign: "center",
              width: "6rem",
              letterSpacing: "0.4rem",
            }}
            autoFocus
          />
          <br />
          <button
            type="submit"
            style={{
              marginTop: "1rem",
              padding: "0.6rem 1.5rem",
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            Acceder
          </button>
        </form>
      </div>
    );
  }

  return (
    <div style={{ padding: "2rem" }}>
      <h1>Resultados de votación</h1>
      <ul style={{ listStyle: "none", padding: 0 }}>
        {totals.map((song, index) => (
          <li key={song.id} style={{ marginBottom: "0.5rem" }}>
            <strong>{index + 1}.</strong> {song.name} —{" "}
            <b>{song.total} pts</b>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Results;
